import React, { useEffect, useState } from 'react';
import { Modal, ModalDialog, DialogTitle, DialogContent, Button, Checkbox, Box, Typography } from '@mui/joy';
import { Campaign } from '@mui/icons-material';
import MailAPI from '../api.ts';

const api = new MailAPI();
const HIDDEN_ANNOUNCEMENTS_KEY = 'hiddenAnnouncements';

const AnnouncementModal: React.FC = () => {
  const [announcement, setAnnouncement] = useState<{ id: string; content: string } | null>(null);
  const [open, setOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const data = await api.getAnnouncement();
        if (data) {
          // Kiểm tra xem announcement này đã bị ẩn chưa
          const hiddenIds = getHiddenAnnouncementIds();
          if (!hiddenIds.includes(data.id)) {
            setAnnouncement(data);
            setOpen(true);
          }
        }
      } catch (error) {
        console.error('Failed to fetch announcement:', error);
      }
    };

    fetchAnnouncement();
  }, []);

  const getHiddenAnnouncementIds = (): string[] => {
    try {
      const stored = localStorage.getItem(HIDDEN_ANNOUNCEMENTS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  };

  const addHiddenAnnouncementId = (id: string) => {
    try {
      const hiddenIds = getHiddenAnnouncementIds();
      if (!hiddenIds.includes(id)) {
        hiddenIds.push(id);
        localStorage.setItem(HIDDEN_ANNOUNCEMENTS_KEY, JSON.stringify(hiddenIds));
      }
    } catch (error) {
      console.error('Failed to save hidden announcement:', error);
    }
  };

  const handleClose = () => {
    if (dontShowAgain && announcement) {
      addHiddenAnnouncementId(announcement.id);
    }
    setOpen(false);
  };

  if (!announcement) {
    return null;
  }

  return (
    <Modal 
      open={open} 
      onClose={handleClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <ModalDialog
        sx={{
          maxWidth: 600,
          width: '90%',
          maxHeight: '80vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Campaign color="primary" />
            <Typography level="h4">Announcement</Typography>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            overflowX: 'hidden',
            overflowY: 'auto'
          }}
        >
          <Box
            sx={{
              mb: 2,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              width: '100%',
              maxWidth: '100%',
              overflowX: 'hidden',
              '& *': {
                maxWidth: '100%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                boxSizing: 'border-box'
              },
              '& img': {
                maxWidth: '100%',
                height: 'auto',
                display: 'block'
              },
              '& pre': {
                overflowX: 'auto',
                maxWidth: '100%'
              }
            }}
            dangerouslySetInnerHTML={{ __html: announcement.content }}
          />
          
          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Checkbox
              label="Don't show this announcement again"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            
            <Button 
              onClick={handleClose}
              fullWidth
              color="primary"
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default AnnouncementModal;
